window.AreyQuizResults = {
  productImages: {},
  heroImages: {},
  variantIds: {},

  normalizeSingle(value) {
    if (!value) return "";
    const cleaned = String(value).replace(/\+/g, " ").trim().toLowerCase();

    const map = {
      "none": "none",
      "a little": "little",
      "some": "some",
      "quite a bit": "quite_a_bit",
      "fine": "fine",
      "medium": "medium",
      "coarse": "coarse",
      "straight": "straight",
      "wavy": "wavy",
      "curly": "curly",
      "coily": "coily",
      "yes": "yes",
      "no": "no"
    };

    return map[cleaned] || cleaned
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  },

  parseGoals(value) {
    if (!value) return [];
    const raw = String(value).replace(/\+/g, " ").toLowerCase();
    const goals = [];

    if (
      raw.includes("slow greying") ||
      raw.includes("slow graying") ||
      raw.includes("appearance of grey") ||
      raw.includes("appearance of gray")
    ) goals.push("slow_greying");

    if (
      raw.includes("support thicker, fuller hair") ||
      raw.includes("thicker, fuller hair")
    ) goals.push("thicker_fuller");

    if (raw.includes("improve hair health")) goals.push("hair_health");

    return goals;
  },

  parseSolutions(value) {
    if (!value) return [];
    const raw = String(value).replace(/\+/g, " ").toLowerCase();
    const solutions = [];

    if (raw.includes("daily supplement")) solutions.push("supplement");
    if (raw.includes("daily topical serum")) solutions.push("serum");
    if (raw.includes("shampoo") || raw.includes("conditioner")) solutions.push("wash");

    return solutions;
  },

  getStateFromUrl() {
    const params = new URLSearchParams(window.location.search);

    return {
      goals: this.parseGoals(params.get("goals")),
      grey: this.normalizeSingle(params.get("grey")),
      texture: this.normalizeSingle(params.get("texture")),
      hairType: this.normalizeSingle(params.get("hairtype")),
      solutions: this.parseSolutions(params.get("solutions")),
      pregnant: this.normalizeSingle(params.get("pregnant"))
    };
  },

  getConditioner(state) {
    return (
      state.grey === "quite_a_bit" ||
      state.texture === "coarse" ||
      state.hairType === "curly" ||
      state.hairType === "coily"
    ) ? "deep" : "smooth";
  },

  getGoalCategory(state) {
    if (state.goals.includes("slow_greying")) return "mentions_greying";
    if (state.goals.includes("thicker_fuller")) return "thicker_without_greying";
    if (state.goals.includes("hair_health")) return "hair_health_only";
    return "general";
  },

  getBaseExperience(state) {
    if (state.pregnant === "yes") return "pregnancy_shower";

    const supplement = state.solutions.includes("supplement");
    const serum = state.solutions.includes("serum");
    const wash = state.solutions.includes("wash");
    const goal = this.getGoalCategory(state);

    if (supplement && serum && wash) {
      return goal === "hair_health_only" ? "two_ways" : "core_routine";
    }

    if (supplement && serum && !wash) {
      return goal === "thicker_without_greying" ? "dream" : "system";
    }

    if (supplement && !serum && wash) {
      return goal === "hair_health_only" ? "shower" : "ntg";
    }

    if (!supplement && serum && wash) {
      return goal === "hair_health_only" ? "shower" : "ampm";
    }

    if (supplement && !serum && !wash) return "ntg";
    if (!supplement && serum && !wash) return "ampm";
    if (!supplement && !serum && wash) return "shower";

    return "general";
  },

  getExperienceData(experience, conditioner) {
    const config = window.AREY_RESULTS_CONFIG;
    const item = config.experiences[experience] || config.experiences.general;

    const title = item.titles ? item.titles[conditioner] : item.title;
    const description = item.descriptions ? item.descriptions[conditioner] : item.description;
    const products = Array.isArray(item.products) ? item.products : (item.products[conditioner] || []);

    return {
      heading: item.heading,
      title,
      summary: item.summary,
      description,
      products
    };
  },

  getProduct(key) {
    const base = window.AREY_RESULTS_CONFIG.products[key];
    if (!base) return null;

    return {
      ...base,
      image: this.productImages[key] || ""
    };
  },

  getHeroImage(experience, conditioner, productKeys) {
    const exactKey = `${experience}_${conditioner}`;
    const genericKey = experience;

    if (this.heroImages[exactKey]) return this.heroImages[exactKey];
    if (this.heroImages[genericKey]) return this.heroImages[genericKey];

    const product = productKeys.map(k => this.getProduct(k)).find(p => p && p.image);
    return product ? product.image : "";
  },

  displayGoal(goal) {
    return {
      slow_greying: "Slow greying",
      thicker_fuller: "Thicker + fuller",
      hair_health: "Hair health"
    }[goal] || goal;
  },

  displayHairType(value) {
    if (!value) return "";
    return value.charAt(0).toUpperCase() + value.slice(1).replace(/_/g, " ");
  },

  displaySolutions(values) {
    const map = {
      supplement: "Supplement",
      serum: "Topical serum",
      wash: "Shampoo + conditioner"
    };
    return values.map(v => map[v] || v);
  },

  renderBadges(state) {
    const el = document.getElementById("arey-result-badges");
    if (!el) return;

    const badges = [
      ...state.goals.map(g => this.displayGoal(g)),
      state.hairType ? `${this.displayHairType(state.hairType)} hair` : "",
      ...this.displaySolutions(state.solutions)
    ].filter(Boolean).slice(0, 5);

    el.innerHTML = badges.map(v => `<li>${v}</li>`).join("");
  },

  renderHeroImage(experience, conditioner, productKeys) {
    const img = document.getElementById("arey-routine-image");
    const placeholder = document.getElementById("arey-routine-image-placeholder");
    const heroImage = this.getHeroImage(experience, conditioner, productKeys);

    if (heroImage && img) {
      img.src = heroImage;
      img.alt = "Your personalized Arey routine";
      img.hidden = false;
      if (placeholder) placeholder.hidden = true;
    } else if (img) {
      img.hidden = true;
      if (placeholder) placeholder.hidden = false;
    }
  },

  renderProducts(productKeys) {
    const container = document.getElementById("arey-result-products");
    if (!container) return;

    container.innerHTML = productKeys.map((key, index) => {
      const p = this.getProduct(key);
      if (!p) return "";

      const variantId = String(this.variantIds[key] || "").trim();
      const canAdd = /^\d+$/.test(variantId);

      const visual = p.image
        ? `<img src="${p.image}" alt="${p.title}" loading="lazy">`
        : `<div class="arey-product-card__placeholder">AREY</div>`;

      const action = canAdd
        ? `<button type="button" class="arey-product-card__add" data-arey-add data-product-key="${key}" data-variant-id="${variantId}">Add to cart</button>`
        : `<a href="${p.url}" target="_blank" rel="noopener">View product</a>`;

      return `
        <article class="arey-product-card">
          <a class="arey-product-card__visual" href="${p.url}" target="_blank" rel="noopener">
            ${visual}
          </a>
          <div class="arey-product-card__body">
            <p class="arey-product-card__kicker">${index === 0 ? "Primary recommendation" : p.kicker}</p>
            <h3>${p.title}</h3>
            <p>${p.description}</p>
            <div class="arey-product-card__footer">
              <span>${p.price}</span>
              ${action}
            </div>
          </div>
        </article>
      `;
    }).join("");

    container.querySelectorAll("[data-arey-add]").forEach(button => {
      button.addEventListener("click", () => {
        this.addOneToCart(button.dataset.variantId, button);
      });
    });
  },

  async addOneToCart(variantId, button) {
    if (!variantId) return;

    const original = button ? button.textContent : "";
    if (button) {
      button.disabled = true;
      button.textContent = "Adding…";
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json", "Accept": "application/json"},
        body: JSON.stringify({items: [{id: Number(variantId), quantity: 1}]})
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || "Unable to add this item to cart.");
      }

      if (button) button.textContent = "Added ✓";
      this.showCartMessage("Added to cart.");
      window.dispatchEvent(new CustomEvent("cart:refresh"));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));

      setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      }, 1400);
    } catch (error) {
      console.error("Arey add to cart error", error);
      if (button) {
        button.disabled = false;
        button.textContent = "Try again";
      }
      this.showCartMessage(error.message || "Could not add this item to cart.", true);
    }
  },

  async addAllToCart(productKeys, button) {
    const items = productKeys
      .map(key => this.variantIds[key])
      .filter(id => /^\d+$/.test(String(id || "").trim()))
      .map(id => ({id: Number(id), quantity: 1}));

    if (!items.length) {
      this.showCartMessage("Add variant IDs in the Theme Editor to enable Add all to cart.", true);
      return;
    }

    const original = button ? button.textContent : "";
    if (button) {
      button.disabled = true;
      button.textContent = "Adding routine…";
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json", "Accept": "application/json"},
        body: JSON.stringify({items})
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || "Unable to add the routine to cart.");
      }

      if (button) button.textContent = "Routine added ✓";
      this.showCartMessage(`${items.length} item${items.length === 1 ? "" : "s"} added to cart.`);
      window.dispatchEvent(new CustomEvent("cart:refresh"));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));

      setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      }, 1600);
    } catch (error) {
      console.error("Arey add all error", error);
      if (button) {
        button.disabled = false;
        button.textContent = "Try again";
      }
      this.showCartMessage(error.message || "Could not add the routine to cart.", true);
    }
  },

  showCartMessage(message, isError = false) {
    const el = document.getElementById("arey-cart-message");
    if (!el) return;
    el.textContent = message;
    el.classList.toggle("is-error", isError);
    el.hidden = false;
    clearTimeout(this.cartMessageTimer);
    this.cartMessageTimer = setTimeout(() => { el.hidden = true; }, 3200);
  },

  renderCartActions(productKeys) {
    const button = document.getElementById("arey-add-all");
    const note = document.getElementById("arey-add-all-note");
    if (!button || !note) return;

    const configured = productKeys.filter(key =>
      /^\d+$/.test(String(this.variantIds[key] || "").trim())
    );

    if (!configured.length) {
      button.hidden = true;
      note.hidden = false;
      note.textContent = "Cart actions will appear once Shopify variant IDs are added in the Theme Editor.";
      return;
    }

    button.hidden = false;
    note.hidden = configured.length === productKeys.length;

    if (!note.hidden) {
      note.textContent = `${configured.length} of ${productKeys.length} recommended items are currently configured for cart add.`;
    }

    button.onclick = () => this.addAllToCart(productKeys, button);
  },

  renderWhy(state, goalCategory, conditioner, experience) {
    const goalTitles = {
      mentions_greying: "Preserve pigment + support healthier hair",
      thicker_without_greying: "Support thicker, fuller-looking hair",
      hair_health_only: "Improve overall hair health",
      general: "Support your hair goals"
    };

    const goalCopies = {
      mentions_greying: "You selected a greying goal, so your result prioritizes pigment support while still accounting for hair health and density.",
      thicker_without_greying: "You selected thicker, fuller hair without a greying goal, so the experience leans into density-focused support.",
      hair_health_only: "You selected overall hair health, so the result favors a flexible routine rather than a greying-led path.",
      general: "Your goals are used to personalize the story around the routine."
    };

    document.getElementById("arey-why-goals-title").textContent = goalTitles[goalCategory];
    document.getElementById("arey-why-goals-copy").textContent = goalCopies[goalCategory];

    const profileTitle = document.getElementById("arey-why-profile-title");
    const profileCopy = document.getElementById("arey-why-profile-copy");

    const conditionerRelevant = [
      "pregnancy_shower",
      "core_routine",
      "two_ways",
      "shower"
    ].includes(experience);

    if (conditionerRelevant) {
      profileTitle.textContent =
        conditioner === "deep"
          ? "Deeper conditioning fits your profile"
          : "A lighter conditioner fits your profile";

      profileCopy.textContent =
        conditioner === "deep"
          ? "Your grey level, texture, or curl pattern puts you on the Masque / Deep Treatment path."
          : "Your current profile stays on the Smooth Conditioner / Shower Duo path.";
    } else {
      const hairLabel = state.hairType ? this.displayHairType(state.hairType) : "Your";
      profileTitle.textContent = `${hairLabel} hair informed your routine`;

      profileCopy.textContent =
        "Your hair profile helps personalize the supporting education and experience, without forcing a conditioner recommendation into a routine that doesn’t include one.";
    }

    const solutionLabels = this.displaySolutions(state.solutions);

    document.getElementById("arey-why-routine-title").textContent =
      solutionLabels.length ? solutionLabels.join(" + ") : "Your preferred routine";

    document.getElementById("arey-why-routine-copy").textContent =
      solutionLabels.length
        ? "The core recommendation is built around the formats you said you are willing to add to your routine and stick with."
        : "Choose at least one solution format in the quiz to generate the complete routine.";
  },

  renderTopDetails(experience, data, state) {
    const benefits = {
      pregnancy_shower: [
        "Simplified in-shower routine",
        "Adjusted for pregnancy or breastfeeding",
        "Conditioning matched to your hair profile"
      ],
      core_routine: [
        "Cleansing + conditioning + inside-out support",
        "Built for consistent daily use",
        "Conditioner matched to your profile"
      ],
      two_ways: [
        "Two strong routine paths",
        "Flexible based on how you prefer to care for your hair",
        "Built around overall hair health"
      ],
      system: [
        "Inside-out + outside-in support",
        "Daily scalp and supplement routine",
        "Focused on pigment and density"
      ],
      dream: [
        "Focused on thicker, fuller-looking hair",
        "Morning-to-night support",
        "Built around density-focused care"
      ],
      ntg: [
        "Simple daily foundation",
        "Supplement-led routine",
        "Easy to maintain consistently"
      ],
      ampm: [
        "Day + overnight scalp support",
        "Topical-first routine",
        "Designed for consistency across your day"
      ],
      shower: [
        "Simple in-shower routine",
        "Conditioner matched to your profile",
        "Easy to maintain consistently"
      ],
      general: [
        "Personalized from your quiz answers"
      ]
    };

    const list = document.getElementById("arey-routine-benefits");
    if (list) {
      list.innerHTML = (benefits[experience] || benefits.general)
        .map(item => `<li>${item}</li>`)
        .join("");
    }

    const value = document.getElementById("arey-routine-value");
    if (value) {
      const productObjects = data.products.map(k => this.getProduct(k)).filter(Boolean);
      const total = productObjects.reduce((sum, product) => {
        const num = parseFloat(String(product.price || "").replace(/[^0-9.]/g, ""));
        return sum + (Number.isFinite(num) ? num : 0);
      }, 0);

      if (total > 0) {
        value.textContent = `Routine value: $${total.toFixed(0)}`;
        value.hidden = false;
      } else {
        value.hidden = true;
      }
    }

    const personalized = document.getElementById("arey-routine-personalized");
    if (personalized) {
      const goal = this.getGoalCategory(state);
      const copy = {
        mentions_greying: "Recommended because you selected a greying-related goal.",
        thicker_without_greying: "Recommended because you want to support thicker, fuller-looking hair.",
        hair_health_only: "Recommended because your priority is overall hair health.",
        general: "Recommended from the combination of answers in your quiz."
      };
      personalized.textContent = copy[goal] || copy.general;
    }
  },

  render(state) {
    const conditioner = this.getConditioner(state);
    const goalCategory = this.getGoalCategory(state);
    const experience = this.getBaseExperience(state);
    const data = this.getExperienceData(experience, conditioner);

    document.getElementById("arey-result-heading").textContent = data.heading;
    document.getElementById("arey-result-intro").textContent =
      "Built around your goals, hair profile and the care formats you told us you’re most likely to use.";

    document.getElementById("arey-summary-title").textContent = data.title;
    document.getElementById("arey-summary-copy").textContent = data.summary;
    document.getElementById("arey-routine-title").textContent = data.title;
    document.getElementById("arey-routine-description").textContent = data.description;
    document.getElementById("arey-routine-reason").textContent = data.summary;

    const list = document.getElementById("arey-routine-list");
    list.innerHTML = data.products
      .map(k => this.getProduct(k))
      .filter(Boolean)
      .map(p => `<li>${p.title}</li>`)
      .join("");

    const firstProduct = data.products.map(k => this.getProduct(k)).find(Boolean);
    const cta = document.getElementById("arey-routine-cta");

    if (firstProduct) {
      cta.href = firstProduct.url;
      cta.target = "_blank";
      cta.rel = "noopener";
      cta.textContent =
        experience === "two_ways"
          ? "Compare your options"
          : data.products.length > 1
            ? "Shop your routine"
            : "Shop your recommendation";
    }

    this.renderBadges(state);
    this.renderHeroImage(experience, conditioner, data.products);
    this.renderProducts(data.products);
    this.renderCartActions(data.products);
    this.renderWhy(state, goalCategory, conditioner, experience);
    this.renderTopDetails(experience, data, state);

    const highGrey = document.getElementById("arey-high-grey-content");
    if (highGrey) highGrey.hidden = state.grey !== "quite_a_bit";

    const pregnancy = document.getElementById("arey-pregnancy-content");
    if (pregnancy) pregnancy.hidden = state.pregnant !== "yes";

    const results = document.getElementById("arey-quiz-results");
    if (results) {
      results.dataset.experience = experience;
      results.dataset.conditioner = conditioner;
      results.dataset.goalCategory = goalCategory;
    }

    this.updateDebugPanel({
      state,
      experience,
      conditioner,
      goalCategory,
      products: data.products
    });

    console.log("AREY QUIZ RESULT", {
      state,
      experience,
      conditioner,
      goalCategory,
      products: data.products
    });
  },

  debugStateFromPanel() {
    const goals = [...document.querySelectorAll('[data-debug-goal]:checked')].map(el => el.value);
    const solutions = [...document.querySelectorAll('[data-debug-solution]:checked')].map(el => el.value);

    return {
      goals,
      grey: document.getElementById("arey-debug-grey").value,
      texture: document.getElementById("arey-debug-texture").value,
      hairType: document.getElementById("arey-debug-hairtype").value,
      solutions,
      pregnant: document.getElementById("arey-debug-pregnant").value
    };
  },

  stateToQuery(state, debug = true) {
    const params = new URLSearchParams();

    if (state.goals.length) {
      const goalLabels = {
        slow_greying: "Slow the appearance of grey hair",
        thicker_fuller: "Support Thicker, Fuller Hair",
        hair_health: "Improve Hair Health"
      };
      params.set("goals", state.goals.map(g => goalLabels[g]).join(", "));
    }

    const singleLabels = {
      grey: {
        none: "NONE",
        little: "A LITTLE",
        some: "SOME",
        quite_a_bit: "QUITE A BIT"
      },
      texture: {
        fine: "Fine",
        medium: "Medium",
        coarse: "Coarse"
      },
      hairType: {
        straight: "Straight",
        wavy: "Wavy",
        curly: "Curly",
        coily: "Coily"
      },
      pregnant: {
        yes: "Yes",
        no: "No"
      }
    };

    params.set("grey", singleLabels.grey[state.grey] || state.grey);
    params.set("texture", singleLabels.texture[state.texture] || state.texture);
    params.set("hairtype", singleLabels.hairType[state.hairType] || state.hairType);

    const solutionLabels = {
      supplement: "Daily Supplement",
      serum: "Daily Topical Serum",
      wash: "Shampoo + Conditioner"
    };

    if (state.solutions.length) {
      params.set("solutions", state.solutions.map(s => solutionLabels[s]).join(", "));
    }

    params.set("pregnant", singleLabels.pregnant[state.pregnant] || state.pregnant);

    if (debug) params.set("debug", "1");

    return params.toString();
  },

  setupDebugPanel() {
    const params = new URLSearchParams(window.location.search);
    const panel = document.getElementById("arey-debug-panel");
    if (!panel || params.get("debug") !== "1") return;

    panel.hidden = false;

    const state = this.getStateFromUrl();

    document.querySelectorAll("[data-debug-goal]").forEach(el => {
      el.checked = state.goals.includes(el.value);
    });

    document.querySelectorAll("[data-debug-solution]").forEach(el => {
      el.checked = state.solutions.includes(el.value);
    });

    document.getElementById("arey-debug-grey").value = state.grey || "little";
    document.getElementById("arey-debug-texture").value = state.texture || "medium";
    document.getElementById("arey-debug-hairtype").value = state.hairType || "wavy";
    document.getElementById("arey-debug-pregnant").value = state.pregnant || "no";

    panel.querySelectorAll("input, select").forEach(el => {
      el.addEventListener("change", () => {
        const nextState = this.debugStateFromPanel();
        const query = this.stateToQuery(nextState, true);
        history.replaceState(null, "", `${window.location.pathname}?${query}`);
        this.render(nextState);
      });
    });

    document.getElementById("arey-debug-copy").addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        const button = document.getElementById("arey-debug-copy");
        const original = button.textContent;
        button.textContent = "Copied";
        setTimeout(() => button.textContent = original, 900);
      } catch (e) {
        console.warn("Could not copy URL", e);
      }
    });
  },

  updateDebugPanel(result) {
    const output = document.getElementById("arey-debug-output");
    if (!output) return;

    output.textContent = JSON.stringify({
      experience: result.experience,
      conditioner: result.conditioner,
      goalCategory: result.goalCategory,
      products: result.products,
      state: result.state
    }, null, 2);
  },

  init() {
    try {
      this.productImages = JSON.parse(
        document.getElementById("arey-product-images").textContent
      );
    } catch (e) {
      console.error("Unable to load Arey product image config", e);
      this.productImages = {};
    }

    try {
      this.heroImages = JSON.parse(
        document.getElementById("arey-hero-images").textContent
      );
    } catch (e) {
      console.error("Unable to load Arey routine hero image config", e);
      this.heroImages = {};
    }

    try {
      this.variantIds = JSON.parse(
        document.getElementById("arey-product-variants").textContent
      );
    } catch (e) {
      console.error("Unable to load Arey product variant IDs", e);
      this.variantIds = {};
    }

    this.setupDebugPanel();
    this.render(this.getStateFromUrl());
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (!window.AREY_RESULTS_CONFIG) {
    console.error("AREY_RESULTS_CONFIG did not load.");
    return;
  }

  window.AreyQuizResults.init();
});
